import * as d3 from 'd3-selection'

export default function (selection, fontSize, dimensions) {
  selection.each(function (data) {
    var group = d3.select(this)

    group.selectAll('*').remove() // Clear inner contents.

    let words = group.datum().split(/\s+/).reverse()
      , word
      , line = []
      , lineNumber = 1
      , text = group.append('text')
                      .attr('font-size', fontSize)
                      .attr('y', 0)
                      .attr('dy', '1em') // sets a decent baseline because IE can't do it in CSS

    while (word = words.pop()) {
      line.push(word)
      text.text(line.join(' '))

      if (text.node().getComputedTextLength() > dimensions.gaugeWidth) {
        line.pop()
        text.text(line.join(' '))
        line = [word]
        text = group.append('text')
                      .attr('font-size', fontSize)
                      .attr('y', 0)
                      .attr('dy', ++lineNumber + 'em') // sets a decent baseline because IE can't do it in CSS
                      .text(word)
      }
    }
  })
}
